const mediaItems = [
  {
    title: '《长安诡事录》终极预告',
    desc: '盛唐迷雾重重，真相究竟何在？',
    duration: '02:35',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20at%20night%20with%20lanterns%2C%20mysterious%20figure%20walking%20through%20foggy%20corridor%2C%20dramatic%20cinematic%20lighting%2C%20suspenseful%20movie%20trailer%20style%2C%20warm%20golden%20and%20deep%20red%20tones&width=800&height=450&seq=media-01-trailer&orientation=landscape',
  },
  {
    title: '科幻巨制《星河纪元》幕后特辑',
    desc: '揭秘震撼视效的诞生过程',
    duration: '08:12',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Film%20production%20studio%20with%20green%20screen%20and%20professional%20cameras%2C%20crew%20members%20working%20on%20set%2C%20behind%20the%20scenes%20documentary%20style%2C%20cinematic%20production%20lighting%2C%20professional%20film%20making%20environment&width=800&height=450&seq=media-02-behind-scenes&orientation=landscape',
  },
  {
    title: '年度十大必看影片盘点',
    desc: '编辑团队精心甄选，不容错过',
    duration: '12:48',
    views: '203万',
    img: 'https://readdy.ai/api/search-image?query=Movie%20awards%20ceremony%20stage%20with%20spotlights%20and%20golden%20statues%2C%20elegant%20red%20carpet%20atmosphere%2C%20cinematic%20glamour%20and%20prestige%2C%20warm%20theater%20lighting%2C%20celebration%20and%20excellence%20theme&width=800&height=450&seq=media-03-countdown&orientation=landscape',
  },
  {
    title: '《笑傲江湖录》角色深度解析',
    desc: '每个角色背后的故事与命运',
    duration: '06:20',
    views: '75万',
    img: 'https://readdy.ai/api/search-image?query=Martial%20arts%20warrior%20standing%20on%20misty%20mountain%20peak%20at%20sunset%2C%20flowing%20traditional%20robes%20in%20wind%2C%20epic%20wuxia%20cinematic%20style%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20heroic%20and%20poetic%20composition&width=800&height=450&seq=media-04-character&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
            精彩视频
          </h2>
          <p className="text-sm text-foreground-500">预告片、花絮、盘点，精彩内容一睹为快</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-xl overflow-hidden border border-background-200/60 bg-background-100 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="aspect-[16/9] w-full overflow-hidden relative">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`悟空影视精彩视频：${item.title}`}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 rounded bg-black/70 text-background-50 text-[10px] font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                <div className="flex items-center justify-between mt-1.5">
                  <p className="text-xs text-foreground-500 truncate flex-1 mr-2">{item.desc}</p>
                  <span className="text-[10px] text-foreground-400 whitespace-nowrap">
                    <i className="ri-eye-line mr-0.5"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}